import { createContext, useContext } from 'react';

import type { TableRowContextProps } from './table-row.types';

const TableRowContext = createContext<null | TableRowContextProps>(null);

export function useTableRowContext(): null | TableRowContextProps {
  return useContext(TableRowContext);
}

export default TableRowContext;
